var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShoppingCart7(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.23719 4.28869C1.84423 4.15771 1.41949 4.37008 1.28851 4.76303C1.15752 5.15599 1.36989 5.58073 1.76285 5.71172L3.66176 6.34469C4.08732 6.48654 4.40423 6.84554 4.49221 7.2854L5.94303 14.5395C6.20011 15.8249 7.32875 16.7502 8.63963 16.7502H18.4914C19.7192 16.7502 20.7983 15.9363 21.1356 14.7557L22.7212 9.20624C22.835 8.80797 22.6043 8.39285 22.2061 8.27906C21.8078 8.16527 21.3927 8.39589 21.2789 8.79416L19.6933 14.3436C19.54 14.8802 19.0495 15.2502 18.4914 15.2502H8.63963C8.04378 15.2502 7.53076 14.8296 7.4139 14.2453L5.96308 6.99122C5.76954 6.02353 5.07232 5.23373 4.13611 4.92166L2.23719 4.28869Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.50003 21.0002C10.3284 21.0002 11 20.3286 11 19.5002C11 18.6718 10.3284 18.0002 9.50003 18.0002C8.6716 18.0002 8.00003 18.6718 8.00003 19.5002C8.00003 20.3286 8.6716 21.0002 9.50003 21.0002Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19 19.5002C19 20.3286 18.3284 21.0002 17.5 21.0002C16.6716 21.0002 16 20.3286 16 19.5002C16 18.6718 16.6716 18.0002 17.5 18.0002C18.3284 18.0002 19 18.6718 19 19.5002Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11 8.00018C11.8284 8.00018 12.5 7.32861 12.5 6.50018C12.5 5.67176 11.8284 5.00018 11 5.00018C10.1716 5.00018 9.50003 5.67176 9.50003 6.50018C9.50003 7.32861 10.1716 8.00018 11 8.00018Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0304 5.46985C17.3232 5.76275 17.3232 6.23762 17.0304 6.53051L11.0303 12.5305C10.7375 12.8234 10.2626 12.8234 9.9697 12.5305C9.67681 12.2376 9.67681 11.7628 9.9697 11.4699L15.9697 5.46985C16.2626 5.17696 16.7375 5.17696 17.0304 5.46985Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16 13.0002C16.8284 13.0002 17.5 12.3286 17.5 11.5002C17.5 10.6718 16.8284 10.0002 16 10.0002C15.1716 10.0002 14.5 10.6718 14.5 11.5002C14.5 12.3286 15.1716 13.0002 16 13.0002Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoppingCart7);
export default __webpack_public_path__ + "static/media/shopping-cart-7.c21df8afdd258d9503e1676c2cc296ef.svg";
export { ForwardRef as ReactComponent };